var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.09 30 2.5-1.448-5.276-3.054-.093-.053-.06.035-2.438 1.412L16.091 30zm12.092-18.087V9L16.09 2 4 9v6.2l2.43-1.408 1.433-.83 1.434.83 2.584 1.497v-1.717l1.434-.83 6.717-3.888 1.434-.83 1.433.83 5.285 3.058zm0 11.097v-7.777l-6.718-3.891-6.716 3.892v7.776l6.707 3.885.01.005 6.717-3.89zm-16.455-.019V18.52L7.864 16.28 4 18.52v4.471l3.864 2.237 3.863-2.236z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlux);
export default __webpack_public_path__ + "static/media/FLUX.683dcfe6f5ab898c914d0a68542dc62a.svg";
export { ForwardRef as ReactComponent };